import { useNavigate } from "react-router-dom";
import "./NotFoundPage.css"; // import styles (create this file)

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-black text-white px-3 text-center">
      <div className="d-flex flex-column flex-md-row align-items-center custom-divider text-start">
        <h1 className="display-4 fw-bold me-md-3 pe-md-3 mb-3 mb-md-0 border-md-end border-secondary">
          404
        </h1>
        <p className="lead m-0">This page could not be found.</p>
      </div>

      {/* <div className="mt-4 d-flex flex-column flex-sm-row gap-3">
        <button
          className="btn btn-outline-light btn-lg px-4 py-2"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>
        <button
          className="btn btn-primary btn-lg px-4 py-2"
          onClick={() => navigate("/")}
        >
          Home
        </button>
      </div> */}
      <div className="mt-4 d-flex flex-column flex-sm-row gap-3">
        <button
          className="btn btn-outline-light btn-lg px-4 py-2"
          onClick={() => window.location.reload()}
        >
          Try Again
        </button>
        <a href="/" className="btn btn-primary btn-lg px-4 py-2">
          Home
        </a>
      </div>
    </div>
  );
};

export default NotFoundPage;
